/** Embedded management-bot URLs + NekoHR username → GitLab `member` query value (see management-bot /individual/report). */

export const MANAGEMENT_BOT_BASE = "https://management-bot-api.herokuapp.com";

/** Company-wide overview embedded above the personal report. */
export const COMPANY_OVERVIEW_PATH = "/company/now_doing";

/** Who may use “View as” is defined in `konekoAConfig.js` (`konekoAAdminUsernames`). */

/** localStorage keys for collapsible panel state */
export const STORAGE_COLLAPSE_COMPANY = "nekohr_dashboard_collapse_company";
export const STORAGE_COLLAPSE_PERSONAL = "nekohr_dashboard_collapse_personal";

/** sessionStorage: optional NekoHR username to preview another person’s embedded report */
export const STORAGE_VIEW_AS_USERNAME = "nekohr_dashboard_view_as_username";

/** NekoHR `username` (JWT) → `member` query string expected by management-bot */
export const NEKO_TO_GITLAB_MEMBER_MAP = {
  liam_maneki: "Liam%20Conroy",
  martin_ogg: "Martin%20Ogg",
  Pablo: "L%27homme%20Sage",
  Reegesh: "Reegesh%20Maharjan",
  Oskar: "Oskar%20Strom",
  Aroni: "Aroni%20Hipperson",
  Tsurutani: "Akinori%20Tsurutani",
  Owen: "Owen%20Bennett",
  Jacques: "Marsden%20Jacques",
};

export function companyOverviewEmbedUrl() {
  return `${MANAGEMENT_BOT_BASE}${COMPANY_OVERVIEW_PATH}`;
}

/** Case-insensitive map key (JWT / UI may use different casing than map keys). */
export function resolveNekoUsernameKey(nekoUsername) {
  if (nekoUsername == null || String(nekoUsername).trim() === "") return null;
  const raw = String(nekoUsername).trim();
  const found = Object.keys(NEKO_TO_GITLAB_MEMBER_MAP).find(
    (k) => k.toLowerCase() === raw.toLowerCase()
  );
  return found || null;
}

export function individualReportEmbedUrl(nekoUsername) {
  const key = resolveNekoUsernameKey(nekoUsername);
  if (!key) return null;
  const member = NEKO_TO_GITLAB_MEMBER_MAP[key];
  if (!member) return null;
  return `${MANAGEMENT_BOT_BASE}/individual/report?member=${member}`;
}
